import { SlhCoreForm } from "@slhuicore/form";
import { LitElement } from "lit";
import { customElement } from "lit/decorators.js";
import { formElements } from "@slhui/base";
import { style } from "./assets/form.generated-style";

/**
 * Custom form element, used to gether all form data
 * when used with validation, button has to be outside of validation-observer
 *
 *  ** slots
 * @slot default - Form elements
 * @slot submit-button - must be SLH-BUTTON, used for form submit
 * @slot clear-button - must be SLH-BUTTON, used for clearing the form
 */
@customElement("slh-form")
export default class SlhForm extends SlhCoreForm(LitElement) {
  static styles = style;

  // eslint-disable-next-line class-methods-use-this
  private getFormElements(): string[] {
    return formElements;
  }
}
